import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { Column } from '../../interfaces/models/Column.model';
import { valueColumns } from '../../static-data/table.data';
import { Value } from '../../interfaces/models/value.model';
import { ValueService } from '../../services/value.service';
import { FileUploadModule, UploadEvent } from 'primeng/fileupload';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FontAwesomeService } from '../../services/font-awesome.service';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';

import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { StrategyService } from '../../services/strategy.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { Subject, takeUntil } from 'rxjs';
import { subject } from '@casl/ability';
@Component({
  selector: 'app-strategic-value',
  standalone: true,
  imports: [TableModule,
    CommonModule,
    RouterLink,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    InputTextareaModule,
    DialogModule,
    FormsModule,
    TranslateModule,
    DropdownModule, FileUploadModule, AutoCompleteModule, IconFieldModule, InputIconModule, ConfirmPopupModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './strategic-value.component.html',
  styleUrl: './strategic-value.component.scss'
})

export class StrategicValueComponent implements OnInit, OnDestroy {
  @ViewChild('valueForm') valueForm!: FormGroup;
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  isVisibleModal = false;
  values = [] as Value[];
  set searchIconTerm(value: any) {
    if (!value) {
      this.hasSelectedIcon = false;
    }
    this._searchIconTerm = value;
  }
  get searchIconTerm() {

    return this._searchIconTerm;
  }
  _searchIconTerm!: any;

  searchIconFilterd = [] as {
    id: string
    label: string
    family: string
    prefix: string
    style: string
  }[];
  strategy!: Strategy;
  submitted = false;
  strategyId = '0';
  valueColumns = valueColumns as Column[]
  selectedUpdateValueId = 0;
  selectedValue = {} as Value;
  dir!: 'rtl' | 'ltr';
  hasSelectedIcon = false;

  constructor(private valueService: ValueService,
    private messageService: MessageService,
    private fontAwesomeService: FontAwesomeService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private strategyService: StrategyService,
    private route: ActivatedRoute,
    private directionService: DirectionService
  ) {
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  private unsubscribe$ = new Subject<void>();
  ngOnInit(): void {
    this.route.data.pipe(takeUntil(this.unsubscribe$)).subscribe(({ viewBag }) => {
      this.strategy = viewBag.strategy.data.strategy;
      this.strategyId = viewBag.strategy.data.strategy.id;
      this.values = viewBag.values;
    })


    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
  }


  showValueModal() {
    this.selectedUpdateValueId = 0;
    this.selectedValue = {} as Value;
    this.searchIconTerm = null;
    this.hasSelectedIcon = false;
    this.searchIconFilterd = [];
    this.isVisibleModal = true;
  }
  submitValue() {
    console.log(this.valueForm);
    if (this.selectedUpdateValueId == 0 && this.valueForm.valid) {
      this.valueService.createtValue({
        description: this.valueForm.value['description'],
        name: this.valueForm.value['name'],
        icon: `${this.searchIconTerm['prefix']}  fa-${this.searchIconTerm['id']}`
      },
        +this.strategyId).subscribe((response: any) => {
          this.toastr.success("تمت الاضافة ", "عملية ناجحة");
          this.values = [...this.values, {
            id: response["data"]["entity"]["id"],
            description: this.valueForm.value['description'],
            name: this.valueForm.value['name'],
            icon: `${this.searchIconTerm['prefix']}  fa-${this.searchIconTerm['id']}`
          } as Value] as Value[];

          this.isVisibleModal = false;
          this.selectedUpdateValueId = 0;
          this.selectedValue = {} as Value;
        })




    } else if (this.selectedUpdateValueId > 0) {
      this.valueService.updatetValue({ ...this.selectedValue, icon: `${this.searchIconTerm['prefix']} fa-${this.searchIconTerm['id']}` }, +this.strategyId, this.selectedUpdateValueId).subscribe((response) => {
        this.values = this.values.map(value => {
          if (value.id == this.selectedUpdateValueId) {
            return { ...value, icon: `${this.searchIconTerm['prefix']} fa-${this.searchIconTerm['id']}` }
          } else {
            return value;
          }
        })
        this.toastr.success("تمت الاضافة ", "عملية ناجحة");
        this.isVisibleModal = false;
        this.selectedUpdateValueId = 0;
        this.selectedValue = {} as Value;
      })
    }

  }
  filterIcon(event: AutoCompleteCompleteEvent) {
    const query = (event?.query ?? '').toString().trim();
    this.submitted = true;
    this.fontAwesomeService.getIconByQuery(query).subscribe({
      next: (x: any) => {
        this.submitted = false;
        this.searchIconFilterd = x?.data?.icons ?? [];
      },
      error: () => {
        this.submitted = false;
        this.searchIconFilterd = [];
      }
    });
  }
  onUpload(event: UploadEvent) {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Basic Mode' });
  }
  confirmValueDelete(event: Event, id: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: "هل تريد تأكيد المسح؟",
      accept: () => {
        this.valueService.deletetValue(+this.strategyId, id).subscribe((x) => {
          this.values = this.values.filter(value => value.id != id);
          this.toastr.success("تمت المسح ", "عملية ناجحة");
        })
      },
      reject: () => {
        this.toastr.info("تم الالغاء", "الغاء");
      }
    });
  }
  showUpdateValueModal(valueId: number) {
    this.selectedUpdateValueId = valueId;
    this.selectedValue = { ... this.values.find(x => x.id == valueId) } as Value;
    const parsedIcon = this.fontAwesomeService.parseIconClass(this.selectedValue.icon);
    this.searchIconTerm = parsedIcon;
    this.hasSelectedIcon = !!parsedIcon;
    this.isVisibleModal = !this.isVisibleModal;
  }
  closeValueModal() {
    this.isVisibleModal = false;
    this.selectedUpdateValueId = 0;
    this.selectedValue = {} as Value;
    this.searchIconTerm = null;
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  onSelectIcon(event: any) {
    this.hasSelectedIcon = true;

  }
}
